import React, {useEffect} from "react";
import EditOperatorProfileInformationSection from "./edit-profile-information";
import EditOperatorProfileImageSection from "./edit-profile-picture";
import {useConfigureNotebook} from "../../../../hooks/use-notebook-config";
import useBehavioralAnalyticsTool from "../../../../hooks/use-behavioural-analytics-tool";
import {useOperatorInformationController} from "../../../../hooks/use-operator-information";
import Grid2 from "@mui/material/Unstable_Grid2";

const OperatorProfileView = () => {
    const {getOperatorInformation} = useOperatorInformationController();

    const {configureNotebookTags} = useConfigureNotebook('operator-profile-view');
    const {configureBehavioralTool} = useBehavioralAnalyticsTool();

    /**
     * As soon as the component is mounted:
     * - Configures the notebook tags for the view
     * - Configures the behavioral analytics tool
     */
    useEffect(() => {
        configureNotebookTags((tags) => tags.operatorProfile);
        configureBehavioralTool((tags) => tags.operatorProfile);
    }, [configureNotebookTags, configureBehavioralTool]);


    /**
     * With first render of the component:
     * Calls the api for getting the current information of the user by calling the related api
     * if the api call was successful, sets the [initialValues] to the received data and updates the local storage
     * otherwise, sets the initialValues from the local storage
     */
    useEffect(() => {
        void getOperatorInformation({disregardCache: true});
    }, [getOperatorInformation])

    return (
        <>
            <Grid2 container spacing={4}>
                <Grid2 xs={12}>
                    <p className={'view-title'}>
                        Manage My Profile
                    </p>
                </Grid2>
                <Grid2 xs={12} md={6} xl={4}>
                    <EditOperatorProfileInformationSection/>
                </Grid2>
                <Grid2 xs={12} md={6} xl={8}>
                    <EditOperatorProfileImageSection/>
                </Grid2>
            </Grid2>
        </>
    );
}

export default OperatorProfileView;
